import { Dispatch } from 'react-redux';
import ReaderApi from './ReaderApi';
import { GalleryInfosActionKeys } from '../../containers/Gallery/actions';
import { DriveItemListActionKeys } from '../../containers/DriveItemList/actions';
import store from '../../store';
import { StoreState } from '../../reducers/index';
import Utils from '../../utils';

export class BackofficeModeManager {
	constructor(dispatch: Dispatch<StoreState>) {
		const readerApi = new ReaderApi();
		readerApi.init().then((response) => {
			// logo
			readerApi.addListener('brand.getObject', (response) => {
				const storeState = store.getState();
				const { template } = storeState.galleryInfos;

				if (template && template.brand) {
					const { logo, url } = template.brand;
					response.resolve({
						logo,
						url,
					});
				}
			});

			readerApi.addListener('brand.update', (data) => {
				data.resolve(dispatch({
					type: GalleryInfosActionKeys.UPDATE_TEMPLATE_BRAND,
					value: data.arguments[0],
				}));
			});

			// background media
			readerApi.addListener('backgroundUrl.getObject', (response) => {
				const storeState = store.getState();
				const {
					galleryInfos: { config: { applicationGallery } },
					driveList: { driveItems },
				} = storeState;

				if (Utils.isGalleryMetaFetched()) {
					const { bgMedia } = driveItems[applicationGallery];
					response.resolve(bgMedia);
				}
			});

			readerApi.addListener('backgroundUrl.update', (data) => {
				const storeState = store.getState();
				const {
					galleryInfos: { config: { applicationGallery } },
					driveList: { driveItems },
				} = storeState;

				if (Utils.isGalleryMetaFetched()) {
					const driveItem = driveItems[applicationGallery];
					driveItem.bgMedia = data.arguments[0];

					data.resolve(dispatch({
						type: DriveItemListActionKeys.UPDATE_DRIVE_ITEM,
						item: driveItem,
					}));
				}
			});

			// folder icon
			readerApi.addListener('folderIconUrl.getObject', (response) => {
				const storeState = store.getState();
				const {
					galleryInfos: { config: { applicationGallery } },
					driveList: { driveItems },
				} = storeState;

				if (Utils.isGalleryMetaFetched()) {
					const applicationGalleryItem = driveItems[applicationGallery];
					if (applicationGalleryItem) {
						const { defaultCover } = applicationGalleryItem;
						response.resolve(defaultCover);
					}
				}
			});

			readerApi.addListener('folderIconUrl.update', (data) => {
				const storeState = store.getState();
				const {
					galleryInfos: { config: { applicationGallery } },
					driveList: { driveItems },
				} = storeState;

				if (Utils.isGalleryMetaFetched()) {
					const driveItem = driveItems[applicationGallery];
					if (driveItem) {
						driveItem.defaultCover = data.arguments[0];

						data.resolve(dispatch({
							type: DriveItemListActionKeys.UPDATE_DRIVE_ITEM,
							item: driveItem,
						}));
					}
				}
			});

			// common styles
			readerApi.addListener('commonStyles.getObject', (response) => {
				const storeState = store.getState();
				const { template } = storeState.galleryInfos;

				if (template && template.commonStyles) {
					response.resolve(template.commonStyles);
				}
			});

			readerApi.addListener('commonStyles.update', (data) => {
				data.resolve(dispatch({
					type: GalleryInfosActionKeys.UPDATE_TEMPLATE_COMMONSTYLES,
					value: data.arguments[0],
				}));
			});
		});
	}
}

export default BackofficeModeManager;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/iframeApi/BackofficeModeManager.ts